var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsideMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.9856 315.2896m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M806.912 282.5216H348.16c-18.1248 0-32.8704 14.7456-32.8704 32.8704 0 18.1248 14.7456 32.8704 32.8704 32.8704h458.752c18.1248 0 32.8704-14.7456 32.8704-32.8704 0-18.1248-14.7456-32.8704-32.8704-32.8704z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.9856 512.1024m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M806.912 479.3344H348.16c-18.1248 0-32.8704 14.7456-32.8704 32.8704 0 18.1248 14.7456 32.8704 32.8704 32.8704h458.752c18.1248 0 32.8704-14.7456 32.8704-32.8704 0-18.1248-14.7456-32.8704-32.8704-32.8704z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.9856 708.5056m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M806.912 675.7376H348.16c-18.1248 0-32.8704 14.7456-32.8704 32.8704 0 18.1248 14.7456 32.8704 32.8704 32.8704h458.752c18.1248 0 32.8704-14.7456 32.8704-32.8704 0-18.1248-14.7456-32.8704-32.8704-32.8704z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideMenu);
export default __webpack_public_path__ + "static/media/aside-menu.82d54f67109982cd2708575d0ce8aae1.svg";
export { ForwardRef as ReactComponent };